<template>
  <div>
    <div class="tags is-right">
      <span class="tag is-medium is-primary is-light">{{type}}</span>
    </div>

    <div class="table-container">
      <table class="table is-fullwidth">
        <thead>
        <tr>
          <th style="min-width: 200px">Away</th>
          <th style="min-width: 200px">Home</th>
          <th style="min-width: 200px">Body</th>
          <th style="min-width: 200px">Date</th>
          <th class="has-text-centered">
            <b-button @click="addNewBet" size="is-small" icon-left="plus" type="is-success">Add</b-button>
          </th>
        </tr>
        </thead>
        <tbody>
        <ParlayPickRow v-for="bet in bets"
                       :key="bet.id"
                       :wager="bet"
                       @removeBet="removeBet"
                       @updateBet="updateBet"/>
        </tbody>
      </table>
    </div>


    <div class="columns">
      <div class="column">
        <b-field grouped label="To Win/Risk">
          <b-input expanded placeholder="To Win" type="number" step=".01" v-model.number="gain" /><!--@input="setDefaultRisk"-->
          <b-input expanded placeholder="Risk" type="number" step=".01" v-model.number="risk" />
        </b-field>

        <b-field label="Instructions">
          <b-input type="textarea" v-model="instructions" />
        </b-field>
      </div>

      <div class="column">
        <b-field label="Type">
          <b-input v-model="type" disabled />
        </b-field>
      </div>
    </div>
    <div class="buttons is-right">
      <button @click.prevent="update"
              :disabled="!isDirty || loading"
              :class="`button is-success ${loading ? 'is-loading' : ''}`">
        Save
      </button>
      <b-button type="is-danger is-outlined" :loading="loading" @click="removeParlay">Delete</b-button>
    </div>
  </div>
</template>

<script>
import ParlayPickRow from '@/components/admin/ParlayPickRow';
import {removeManualPick, updateAdminPick} from '@/utils/api';
import {randomString} from '@/utils/misc';

export default {
  components: {
    ParlayPickRow
  },
  props: {
    parlay: Object
  },
  data() {
    return {
      loading: false,
      wagerUpdated: false,
      gain: 0,
      risk: 0,
      instructions: '',
      bets: [],
      type: 'Parlay'
    }
  },
  mounted() {
    this.setInitVals();
  },
  methods: {
    addNewBet: function () {
      this.bets = [
        ...this.bets,
        {
          id: randomString(),
          awayTeam: '',
          homeTeam: '',
          body: '',
          dateTime: new Date(),
          type: 'Parlay'
        }
      ]
    },
    update: async function () {
      let {id, title, service} = this.parlay;
      let { type, bets, risk, gain, instructions } = this;
      bets.sort((a,b) => a.dateTime.getTime() - b.dateTime.getTime());
      let parlayDateTime = bets[0] ? bets[0].dateTime.getTime() : 0;

      let payload = {
        id,
        service,
        edits: {
          title,
          type,
          dateTime: parlayDateTime,
          bets,
          risk,
          gain,
          instructions,
          service
        }
      };

      this.loading = true;
      let res = await updateAdminPick(payload);
      this.loading = false;

      if (!res.ok) {
        this.$buefy.toast.open('Pick Not Updated');
      }

      let resBody = await res.json();
      console.log({resBody});
      this.$buefy.toast.open({
        message: 'Pick Updated',
        type: 'is-success'
      });

      this.$emit('pickUpdated', {...this.parlay, ...this.$data});

    },
    setInitVals: function () {
      let {parlay} = this;

      ['gain', 'risk', 'instructions', 'bets']
        .forEach(datum => {
          if (datum in this && datum in parlay) {
            this[datum] = parlay[datum];
          }
        })
    },
    removeBet: function (id) {
      this.wagerUpdated = true;
      this.bets = this.bets.filter(bet => bet.id !== id);
    },
    updateBet: function ({id, edits}) {
      let betToUpdate = this.bets.find(bet => bet.id === id);
      //let position = this.bets.indexOf(betToUpdate);

      if (!betToUpdate) return;

      // unlink prototype from prop
      // betToUpdate = JSON.parse(JSON.stringify(betToUpdate))

      for(let edit in edits) {
        if (betToUpdate[edit] !== edits[edit]) {
          this.wagerUpdated = true;
          betToUpdate[edit] = edits[edit];
        }
      }

      //console.log({betToUpdate});

      //this.bets.splice(position, 1, betToUpdate);

      if (this.wagerUpdated) {
        this.bets = [...this.bets];
      }
    },
    removeParlay: async function() {
      this.loading = true;
      let res = await removeManualPick({id: this.parlay.id, service: this.parlay.service});
      this.loading = false;

      if (res.ok) {
        this.$buefy.toast.open({
          message: 'Pick Removed',
          type: 'is-success'
        });
        this.$emit('pickRemoved', JSON.parse(JSON.stringify(this.parlay)))
        console.log(await res.json());
      }
    }
    /*setDefaultRisk: function () {
      let {gain} = this;
      let standardOdds = 110/100;
      let standardRisk = gain*standardOdds;

      this.risk = parseFloat(standardRisk.toFixed(2));
    },*/
  },
  computed: {
    isDirty: function () {
      let {parlay, wagerUpdated} = this;

      return ['gain', 'risk', 'instructions']
        .some(key => {
          return this[key] !== parlay[key]
        }) || wagerUpdated;
    }
  }
}
</script>

<style lang="scss">
@import "~buefy/src/scss/utils/functions";
@import "~buefy/src/scss/utils/variables";
@import "~bulma/sass/elements/table";
</style>